<!-- 个人资料 -->
<template>
  <div class="personal-own">
    <ul>
      <li>
        <div>
          <h1>个人头像</h1>
          <div class="personal-own-avatar">
            <img :src="userAvatar||avatar"
                 alt="头像">
            <div class="personal-own-avatar-btn" v-if="isallowedit">
              <Button class="zlr-btn-default"
                      @click="modifyHandle">修改头像</Button>
            </div>
          </div>
        </div>
      </li>
      <li>
        <div>
          <h1>个人信息</h1>
          <div class="personal-own-info">
            <div class="personal-own-info-list" v-if="Object.keys(info).length">
              <span>姓名</span>
              <span>{{isallowedit ? info.name : desensitizedHandler(info.name, 'name')}}</span>
            </div>
            <div class="personal-own-info-list">
              <span>电话</span>
              <span>{{isallowedit ? info.phone: desensitizedHandler(info.phone, 'phone')}}</span>
            </div>
            <div class="personal-own-info-list">
              <span>学校</span>
              <span>{{info.univer}}</span>
            </div>
            <div class="personal-own-info-list">
              <span>院系</span>
              <span>{{info.faculty}}</span>
            </div>
            <div class="personal-own-info-list">
              <span>专业</span>
              <span>{{info.course}}</span>
            </div>
            <div class="personal-own-info-list">
              <span>本科入学年份</span>
              <span>{{info.schoolYear || ''}}</span>
            </div>
          </div>
        </div>
      </li>
      <li>
        <div>
          <h1>申请信息</h1>
          <div class="personal-own-info">
            <div class="personal-own-info-list">
              <span>入学年份</span>
              <span>{{info.inYear || ''}}</span>
            </div>
            <div class="personal-own-info-list">
              <span>申请方向</span>
              <span>{{info.applyField}}</span>
            </div>
            <div class="personal-own-info-list">
              <span>Degree Level</span>
              <span>{{info.studyAbroadType}}</span>
            </div>
            <div class="personal-own-info-list">
              <span>目标学校</span>
              <span>{{info.targetSchool}}</span>
            </div>
          </div>
        </div>
      </li>
      <li>
        <div>
          <h1>个人文件</h1>
          <div class="personal-own-info">
            <div class="personal-own-info-list">
              <span>简历</span>
              <span v-if="isallowedit">
                <template v-if="!info.personalFile || !info.personalFile.cvUrl">
                  <span class="upload blue"
                        @click="handleUploadFile('CV')">上传</span>
                </template>
                <template v-else>
                  <span class="upload blue"
                        @click="handleDownload(info.personalFile.cvUrl)">下载</span> <span class="orange update"
                        @click="handleUploadFile('CV')">更新</span>
                </template>
              </span>
            </div>
            <div class="personal-own-info-list">
              <span>成绩单</span>
              <span v-if="isallowedit">
                <template v-if="!info.personalFile || !info.personalFile.reportCardUrl">
                  <span class="upload blue"
                        @click="handleUploadFile('reportCard')">上传</span>
                </template>
                <template v-else>
                  <span class="upload blue"
                        @click="handleDownload(info.personalFile.reportCardUrl)">下载</span> <span class="orange update"
                        @click="handleUploadFile('reportCard')">更新</span>
                </template>
              </span>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <!-- 上传头像 -->
    <upload-avatar ref="upload"></upload-avatar>
    <!-- 上传文件 -->
    <upload-file ref="uploadFile"
                 :menteeNum="info.num"
                 :type="uploadFileType"
                 @on-upload-success="getDetail"></upload-file>
  </div>
</template>

<script>
import { infoQueryDetail } from '@/api/info'
import { ossSecretLink } from '@/api/oss'
// images
import avatar from '@/assets/images/home/mentee-avatar.svg'
// components
import UploadAvatar from './components/own-avatar'
import UploadFile from './components/own-file'
import { mapState } from 'vuex'
import isAllowEdit from '@/view/mixins/is-edit'
export default {
  name: 'personal-own',
  mixins: [isAllowEdit],
  components: {
    UploadAvatar,
    UploadFile
  },
  data () {
    return {
      avatar,
      info: {},
      uploadFileType: ''
    }
  },
  computed: {
    ...mapState({
      userAvatar: function (state) {
        return state.user.userAvatar
      }
    })
  },
  async created () {
    await this.getDetail()
  },
  methods: {
    getDetail () {
      infoQueryDetail({}).then(res => {
        this.info = res.data.model
      })
    },
    modifyHandle () {
      this.$refs['upload'].uplpadShowHandle()
    },
    handleUploadFile (type) {
      this.uploadFileType = type
      this.$refs['uploadFile'].handleShow()
    },
    // 下载
    handleDownload (url) {
      ossSecretLink({
        dir: url
      }).then(res => {
        window.open(res.data.url)
      })
    }
  }
}
</script>
<style lang='less' scoped>
</style>
